import React, { useState, useEffect, useRef } from 'react';
import axios from 'axios';
import './../../styles/cliente/pedidos_calificar.css';
import * as globals from './../../components/GlobalScripts.js';
import { Link, useNavigate } from 'react-router-dom';

const Cliente_pedidos_calificar = () => {
    let path_api = localStorage.getItem('path_api');
    const navigate = useNavigate();
    const [user, setUser] = useState({});
    const [formDataPlatillo, setFormDataPlatillo] = useState({});
    const [formDataReview, setFormDataReview] = useState({});

    useEffect(() => {
        const user_cache = localStorage.getItem('user');
        if (user_cache) {
            let userParsed = JSON.parse(user_cache);
            if (userParsed) {
                setUser(userParsed);
            }
        }

        const platillo_cache = localStorage.getItem('platillo');
        if (platillo_cache) {
            let platilloParsed = JSON.parse(platillo_cache);
            if (platilloParsed) {
                setFormDataPlatillo(platilloParsed);
                setFormDataReview({
                    order_id: platilloParsed.id,
                    platillo: platilloParsed.snapshot.main.nombre,
                    description: '',
                    rating: 5
                })
            }
        }
    }, []);

    const handleSubmit = async (e) => {
        e.preventDefault();

        globals.openViewCharge();
        axios.post(`${path_api}/update-orders/review.php`, {
            rute: globals.getRuteBackend(),
            session_id: globals.get_session_id(),
            keylogin: globals.get_keylogin(),
            review: formDataReview,
        }).then(response => {
            if (response.data.mensaje === 'success') {
                globals.createAlert({
                    type: "success",
                    msg_title: "Exito",
                    msg: "Calificacón enviada.",
                    effect: "opacidad 2s, desplazamiento 2s",
                    time_life: 4000
                });
                navigate(`/cliente/pedidos`);
            } else {
                globals.createAlert({
                    type: "error",
                    msg_title: "Error",
                    msg: response.data.mensaje || "Error al calificar",
                    effect: "opacidad 2s, desplazamiento 2s",
                    time_life: 4000
                });
            }
        }).catch(error => {
            globals.createAlert({
                type: "error",
                msg_title: "Error",
                msg: "Error al conectar con el servidor",
                effect: "opacidad 2s, desplazamiento 2s",
                time_life: 4000
            });
        }).finally(() => {
            globals.closeViewCharge();
        });
    };

    const handleChange = (e) => {
        const { name, value } = e.target;
        setFormDataReview({ ...formDataReview, [name]: value });
    };

    return (
        <div className='page-pedidos-calificar container-section small-section flex-column gap-20'>
            <form onSubmit={handleSubmit} className="flex-column gap-20">
                <Link to="/cliente/pedidos" className="flex-row gap-5">
                    <svg width="20" viewBox="0 0 100 70" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path d="M24.163 41.125L38.7085 55.6658L38.7088 55.6662C39.2779 56.2353 39.7294 56.9109 40.0374 57.6545C40.3454 58.3981 40.5039 59.1951 40.5039 60C40.5039 60.8049 40.3454 61.6018 40.0374 62.3454C39.7294 63.089 39.2779 63.7647 38.7088 64.3338C38.1397 64.9029 37.464 65.3544 36.7204 65.6624C35.9768 65.9704 35.1798 66.1289 34.375 66.1289C33.5701 66.1289 32.7732 65.9704 32.0296 65.6624C31.2859 65.3544 30.6103 64.9029 30.0412 64.3338L5.04386 39.3365C5.04297 39.3356 5.04207 39.3347 5.04118 39.3338M24.163 41.125L36.5875 12.2125C36.878 11.9219 37.1085 11.577 37.2658 11.1974C37.423 10.8178 37.5039 10.4109 37.5039 10C37.5039 9.5891 37.423 9.18222 37.2658 8.8026C37.1085 8.42298 36.878 8.07805 36.5875 7.7875C36.2969 7.49695 35.952 7.26647 35.5724 7.10923C35.1928 6.95198 34.7859 6.87105 34.375 6.87105C33.9641 6.87105 33.5572 6.95198 33.1776 7.10923C32.798 7.26647 32.453 7.49695 32.1625 7.7875L7.1625 32.7875C6.87148 33.0778 6.64059 33.4226 6.48305 33.8023C6.32551 34.1819 6.24441 34.589 6.24441 35C6.24441 35.411 6.32551 35.818 6.48305 36.1977C6.64059 36.5774 6.87148 36.9222 7.1625 37.2125L5.04118 39.3338M24.163 41.125H90.625C92.2494 41.125 93.8074 40.4797 94.956 39.331C96.1047 38.1824 96.75 36.6244 96.75 35C96.75 33.3755 96.1047 31.8176 94.956 30.669C93.8074 29.5203 92.2495 28.875 90.625 28.875H24.163L38.7085 14.3342L38.7088 14.3338C39.2779 13.7647 39.7294 13.089 40.0374 12.3454C40.3454 11.6018 40.5039 10.8049 40.5039 10C40.5039 9.19513 40.3454 8.39815 40.0374 7.65455C39.7294 6.91095 39.2779 6.2353 38.7088 5.66618C38.1397 5.09705 37.464 4.6456 36.7204 4.33759C35.9768 4.02958 35.1799 3.87105 34.375 3.87105C33.5701 3.87105 32.7731 4.02958 32.0296 4.33759C31.286 4.6456 30.6103 5.09705 30.0412 5.66618L5.04386 30.6635L7.16215 32.7871L5.04118 30.6662M24.163 41.125L5.04118 30.6662M5.04118 39.3338C4.47204 38.7654 4.02043 38.0905 3.71213 37.3475C3.40336 36.6034 3.24441 35.8056 3.24441 35C3.24441 34.1943 3.40336 33.3966 3.71213 32.6525C4.02043 31.9095 4.47204 31.2346 5.04118 30.6662M5.04118 39.3338L5.04118 30.6662" fill="var(--color-primary)" stroke="var(--color-primary)" strokeWidth="6" />
                    </svg>
                    <h4 style={{ color: "var(--color-primary)" }}>Volver</h4>
                </Link>
                <h3>Calificando</h3>

                <div className="review-item">
                    <h5>Platillo: <b>{formDataPlatillo?.snapshot?.main?.nombre}</b></h5>

                    <div className="form-group">
                        <label htmlFor="rating">(0 al 5)</label>
                        <input
                            type="number"
                            id="rating"
                            name="rating"
                            value={formDataReview.rating}
                            onChange={handleChange}
                            className="input-primary"
                            placeholder="0-5"
                            required
                            style={{ maxWidth: "100px" }}
                            min="0"
                            max="5"
                            onKeyDown={(e) => {
                                const allowedKeys = ["Backspace", "Tab", "ArrowLeft", "ArrowRight", "Delete", "Enter"];
                                if (allowedKeys.includes(e.key)) return;
                                if (!/^\d$/.test(e.key)) {
                                    e.preventDefault();
                                }
                            }}
                        />
                    </div>
                    <div className="form-group">
                        <label htmlFor="description">Describre tu experiencia con el platillo</label>
                        <textarea
                            type="text"
                            id="description"
                            name="description"
                            value={formDataReview.description}
                            onChange={handleChange}
                            className="input-primary"
                            placeholder="EJ: Muy rico."
                            rows="3"
                        />
                    </div>

                    <p className='text-green'>Tu calificación nos ayuda para seguir mejorando.</p>
                </div>

                <div className="buttons-opt">
                    <button className="button-primary" type="submit">
                        Enviar
                    </button>
                </div>
            </form>
        </div>
    );
};

export default Cliente_pedidos_calificar;